export var AtrsRoutes = {
    "/atrs/brand/{brandId:[0-9]+}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.atrs-listing",
        "params": {brandId: ""},
        "type": "frontend",
        "component": "atrsListing",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["authority_to_recruit"]
        },
        "onEnter": [function () {
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./authority-to-recruit.module.js");
                },
            },
        ],
    },

    "/atrs/brand/{brandId:[0-9]+}/manage/{atrId:[0-9]*}": {
        "loginRequired": true,
        "name": "appLayout.harriSH.atr-manage",
        "params": {atrId: ""},
        "type": "frontend",
        "component": "atrManage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["authority_to_recruit"]
        },
        "onEnter": [function () {
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./authority-to-recruit.module.js");
                }
            }
        ],
    },

    "atr-action?brand_id&atr_id&token&action": {
        "name": "homepage.atr-action",
        "type": "frontend",
        "showGlobalSearch": false,
        "views": {
            "atr-action-view": {
                "component": "atrApproveReject",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["authority_to_recruit"]
        },
        "onEnter": [function () {
        }],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./authority-to-recruit.module.js");
                }
            }
        ],
    }
};